module.exports = __webpack_public_path__ + "static/media/lk.b33dbf15.png";